export default __webpack_public_path__ + "79ee165.mp3";